import { NO_INSURANCE_RE } from './police.js';
import { isPlaceholderCarrier } from './side.js';
const words = (v) => v.toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean).join(' ');
const realCarrier = (c) => !!c && !!c.trim() && !NO_INSURANCE_RE.test(c) && !isPlaceholderCarrier(c);
const ACCOUNT = /^001[A-Za-z0-9]{12}([A-Za-z0-9]{3})?$/;
const ms = (v) => (v ? Date.parse(v) || 0 : 0);
/** The pipeline's write status, in words: why the carrier is not on the case yet. */
export const POLICE_NOT_AUTO = {
    skipped_duplicate_ingest: 'this page of the report came in as its own file and the police-report pipeline set it aside as a duplicate of another page',
    pending: 'its police-report review card is still waiting for a person',
    blocked: 'the police-report pipeline held it for a person',
    auto_pending: 'the police-report pipeline has not saved it yet',
    superseded: 'the police-report pipeline replaced this read with another file',
};
const CONFIDENCE = { MEDIUM: 'a medium-confidence read', LOW: 'a low-confidence read' };
/** The evidence for a side with no record whose police report names `carrier`; null when no read of that side names it. */
export function policeEvidenceFor(side, carrier, files) {
    if (!realCarrier(carrier))
        return null;
    const key = words(carrier);
    const ofSide = files.filter((f) => f.party === side && realCarrier(f.carrier)).slice().sort((a, b) => ms(b.doc_at) - ms(a.doc_at));
    const named = ofSide.filter((f) => words(f.carrier) === key);
    const withFile = named.filter((f) => !!f.file_id);
    if (!withFile.length)
        return null;
    const seen = new Set();
    const list = [];
    for (const f of withFile) {
        if (seen.has(f.file_id.slice(0, 15)))
            continue;
        seen.add(f.file_id.slice(0, 15));
        list.push({ fileId: f.file_id, name: f.file_name?.trim() || 'police report', at: f.doc_at });
    }
    // one account across every read naming the carrier; a read with no account does not count against it, two different accounts do
    const accounts = new Set(named.map((f) => f.carrier_account_id).filter((a) => !!a && ACCOUNT.test(a)).map((a) => a.slice(0, 15)));
    const accountId = accounts.size === 1 ? named.find((f) => f.carrier_account_id && f.carrier_account_id.slice(0, 15) === [...accounts][0]).carrier_account_id : null;
    const other = ofSide.find((f) => words(f.carrier) !== key);
    const newest = withFile[0];
    const why = [POLICE_NOT_AUTO[String(newest.write_status ?? '')], CONFIDENCE[String(newest.confidence ?? '').toUpperCase()]].filter(Boolean);
    return { carrier, files: list.slice(0, 3), accountId, otherCarrier: other ? other.carrier : null, notAuto: why.length ? why.join('; ') : null };
}
/** Approve on this row: a side with no record, a person's to do on THIS case (not a second client's, not one sent to the main client's case),
 *  one matched insurer and no other carrier named for the side. */
export function policeApproveable(r) {
    const e = r.policeEvidence;
    return !!e && !!e.accountId && !e.otherCarrier && !!r.gap && (r.gap.key === 'police_names' || r.gap.key === 'plt_police')
        && r.status === 'need' && r.fix === 'gap' && !r.secondClient;
}
//# sourceMappingURL=police_evidence.js.map